<template>
    <div>
        <div>
        <h1>Przypisanie użytkowników</h1>
        <button class="btnAdmin" @click="enableConfig">Edytuj użytkowników</button>
        <div class="tablebox">
            <table>
            <thead> 
                <th>Użytkownik panelu</th>
                <th>Email</th>
                <th>Pracownik maga</th>
            </thead>
            <tbody v-for="user in mergedUsers" :key="user.id">
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>
                <select v-model="user.id_pracownika_maga" :disabled="disabledS" v-on:change="selectedData($event, user.id)">
                    <option v-for="worker in usersMag" :value="worker.ID_PRACOWNIKA" v-bind:key="worker.ID_PRACOWNIKA">{{ worker.NAZWA }}</option>
                </select>
                </td>
            </tbody>
        </table>
        </div>
        <button class="btnAdmin" @click="saveUsers" :disabled="disabledS">Zapisz użytkowników</button>
        </div>
         <div class="wleft">
            <button class="wlabel" @click="wrocclick"> WRÓĆ </button>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Storage from "../Storage.vue";
import * as CONFIG from "../config.js";
export default {
    data: () => ({
        users: [],
        usersMag: [],
        usersWorkers: [],
        mergedUsers: [],
        jwt: "",
        url: CONFIG.API_DOMAIN + 'users',
        urlUsersMag: '/agent/GALEK.Magazyn/GetPracownicy',
        urlUsersWorkers: '/agent/GALEK.Magazyn/GetUzytkownicyPaneluPracownicy',
        urlPost: '/agent/GALEK.Magazyn/ZapiszUzytkownikowPanelu',
        requestBody: {},
        disabledS: true,
        usersToSave: "",

    }),
    methods:{
        wrocclick(){
            this.$router.push({ path: "/paneladmin" });
        },
        selectedData(e, id) {
            var objIndex = this.mergedUsers.findIndex((obj => obj.id === id))
            this.mergedUsers[objIndex].id_pracownika_maga = e.target.value
        },
        getData() {
            return axios
                .get(this.url, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        getUsersMag() {
            return axios
                .get(CONFIG.API_URL + this.urlUsersMag, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        getUsersWorkers() {
            return axios
                .get(CONFIG.API_URL + this.urlUsersWorkers, {
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Accept": "application/json",
                        "Authorization": "Bearer " +  this.jwt,
                }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        saveUsers(){
            this.usersToSave = ""
            var temparray = this.mergedUsers
            var tempStr = ""
            for (let i = 0; i < temparray.length; i++){
                tempStr = tempStr + temparray[i].id_uzytkownika_panelu + ',' + temparray[i].id_pracownika_maga + ';'
            }
            this.usersToSave = {uzytkownicy: tempStr}
            this.postData()
            this.disabledS = true;
        },
        postData() {
            return axios
                .post(CONFIG.API_URL + this.urlPost, 
                this.usersToSave,
                {
                    headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            "Accept": "application/json",
                            "Authorization": "Bearer " +  this.jwt,
                    }
                })
                .then(response => {
                        return response.data;
                })
                .catch(e => {
                        alert("ERROR" + e);
                });
        },
        enableConfig(){
            this.disabledS = !this.disabledS ;
        },
        mergeTables(data, datauw){
            var tempMergedTables = []
            for(let i = 0; i < data.length; i++){
                var tempid = data[i].id
                var tempUW = datauw.filter(uw => uw.id_uzytkownika_panelu === tempid)
                var tempConnect = {...tempUW[0], ...data[i]}
                tempMergedTables.push(tempConnect)
            }
            this.mergedUsers = tempMergedTables
        }
    },
    mounted() {
        var that = this

	    Storage.loadJWT("jwt").then(resp => {
		//alert(resp.access_token);
            that.jwt = resp.access_token;
            that.getData().then(data => {
                that.users = data
                that.getUsersWorkers().then(datauw => {
                that.usersWorkers = datauw
                that.mergeTables(data, datauw);
                }) 
            })
            that.getUsersMag().then(data => {
                that.usersMag = data
            }) 
            
            
        });
    
    }
}
</script>

<style>
    .tablebox{
        padding: 10px;
    }
    .tablebox > table{
        text-align: center;
        margin:auto;
        width: 100%;
        border-collapse: collapse;
        border: solid 1px rgba(34, 34, 34, 0.5);
        box-shadow: 0 0 20px rgba(34, 34, 34, 0.5);
    }
    .tablebox > table > thead{
        box-shadow: 0 0 10px rgba(34, 34, 34, 0.5);
    }
    .wright {
            width: 200px;
            height: 50px;
            position:fixed;
            bottom: 10px;
            right: 10px;
            text-align: right;
            background-color: #FFFFFF;
            /*padding-top: 10px;*/
            float: right;
            margin-top: 40px;
    }
    .wleft {
            width: 200px;
            height: 50px;
            position:fixed;
            bottom: 10px;
            text-align: left;
            background-color: #FFFFFF;
            float: left;
            margin-top: 40px;
            /*margin-left: 400px;*/
    }
    .wlabel {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/PanelAdministracyjny/Uzytkownicy.vue